import useUser from '../../../../utils/hooks/useUser';
import { isNil } from 'lodash';
import SlackDestinationDropdown from '../../../Slack/SlackDestinationDropdown';
import { InstallSlackButton } from '../../../Slack/InstallSlackButton';
import React from 'react';
import { MaybeNil } from '../../../../utils/interfaces';
import { ISlackDestinationFieldsFragment } from '../../../../utils/apollo/graphqlSchema';
import { LoadingSpinner } from '../../../Loaders';
import DashboardSlackDisconnect from './DashboardSlackDisconnect';

interface IProps {
  loading: boolean;
  value: MaybeNil<ISlackDestinationFieldsFragment>;
  onChange?: (value: MaybeNil<ISlackDestinationFieldsFragment>) => void;
}

export const DashboardSlackDestination = ({
  value,
  onChange,
  loading,
}: IProps) => {
  const user = useUser();

  if (loading) {
    return <LoadingSpinner size="tiny" active={true} />;
  }

  if (!isNil(user.slackInstallation)) {
    if (isNil(value)) {
      return <SlackDestinationDropdown value={value} onChange={onChange} />;
    }

    return (
      <DashboardSlackDisconnect
        destination={value}
        onDisconnect={() => onChange?.(null)}
      />
    );
  } else if (!isNil(value)) {
    return (
      <div>
        <DashboardSlackDisconnect destination={value} disabled={true} />
        <div />
        <InstallSlackButton customButtonLabel="Connect to Slack to edit" />
      </div>
    );
  } else {
    return (
      <InstallSlackButton customButtonLabel="Connect dashboard to Slack" />
    );
  }
};
